<template>
  <div class="black_panel_cla">
    <zk-table
      :data="tableData"
      :columns="columnData"
      style="min-height:300px;height: auto;"
    ></zk-table>
    <div class="pagination-margin-top">
      <el-pagination
        background
        @size-change="changePageSize"
        @current-change="changePage"
        :current-page="pager.curPage"
        :page-size="pager.pageSize"
        layout="total, prev, pager, next, sizes, jumper"
        :total="pager.total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { findDoorByPage } from '@/services/accManager.js'
export default {
  data() {
    return {
      tableData: [],
      params: {},
      columnData: [
        {
          label: this.$t('accManager.doorName'),
          prop: 'doorName'
        },
        {
          label: this.$t('accManager.devAlias'),
          prop: 'devAlias'
        },
        {
          label: this.$t('device.sn'),
          prop: 'sn'
        },
        {
          label: this.$t('accManager.devStatus'),
          prop: 'devStatus',
          render: (h, params) => {
            if (params.row.devStatus === 1) {
              return h(
                'span',
                {
                  class: {
                    'doorDevice-online-cla': true
                  }
                },
                [this.$t('device.online')]
              )
            } else {
              return h(
                'span',
                {
                  class: {
                    'doorDevice-offline-cla': true
                  }
                },
                [this.$t('device.offLine')]
              )
            }
          }
        }
      ]
    }
  },
  mounted() {
    this.commQuery()
  },
  methods: {
    changePage(current) {
      this.pager.curPage = current
      this.commQuery()
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    commQuery() {
      findDoorByPage({
        params: this.params,
        pager: this.pager
      })
        .then(data => {
          if (data.code === '00000000') {
            let payload = data.payload
            this.pager.total = payload.totalRecords
            this.pager.curPage = payload.curPage
            this.pager.pageSize = payload.pageSize
            this.tableData = payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          this.errorMessage()
        })
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/styles/var.less';
/deep/.doorDevice-online-cla {
  color: @themeColor;
}
/deep/.doorDevice-offline-cla {
  color: @ststusFailed;
}</style>



// WEBPACK FOOTER //
// src/modules/accManager/accManager/doorList.vue